

/// <reference path="DBMappingEntity.ts" />

// Generated class DBMappingEntityProduct_ManagedObject

class DBMappingEntityProduct_ManagedObject extends DBMappingEntity
{
}
